import createDOMPurify from 'dompurify'

const purifier = createDOMPurify(window)

purifier.addHook('afterSanitizeAttributes', (node) => {
	if (node.nodeName === 'A') {
		const href = node.getAttribute('href')
		if (href && !/^(https?:\/\/|mailto:|\/)/i.test(href)) {
			node.removeAttribute('href')
		}
		node.setAttribute('target', '_blank')
		node.setAttribute('rel', 'noopener noreferrer nofollow')
	} else {
		for (const attribute of Array.from(node.attributes)) {
			node.removeAttribute(attribute.name)
		}
	}
})

export const sanitizeNoteHtml = (html: string): string =>
	purifier.sanitize(html, {
		ALLOWED_TAGS: [
			'p',
			'br',
			'strong',
			'b',
			'em',
			'i',
			'u',
			's',
			'del',
			'strike',
			'code',
			'a',
		],
		ALLOWED_ATTR: ['href', 'target', 'rel'],
		ALLOW_DATA_ATTR: false,
		ALLOW_ARIA_ATTR: false,
	})
